export default __webpack_public_path__ + "static/media/distributors-dark-green.a7e00317.svg";